import hexToRgba from 'hex-to-rgba';
import { PropTypes } from 'prop-types';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';

import Chevron from '../../../assets/svg/chevron.svg';

const CardImageBasedXLargeControls = ({
  carousel,
  orderClassName,
  realIndex,
  swiper,
  theme,
}) => {
  const chevron = classnames(
    'w-2',
    'lg:w-3',
    'stroke-current',
    'transition-colors',
    'text-[color:var(--swiper-controls-color)]',
    'group-hover:text-[color:var(--swiper-controls-background-color)]',
  );

  const leftChevron = classnames(chevron, 'transform', 'rotate-180');

  const rightChevron = classnames(chevron);

  const button = classnames(
    'group',
    'flex',
    'items-center',
    'justify-center',
    'w-11',
    'h-11',
    'lg:h-13',
    'lg:w-13',
    'transition-colors',
    'bg-[color:var(--swiper-controls-background-color)]',
    'hover:bg-[color:var(--swiper-controls-color)]',
  );

  const leftButton = classnames(button, 'border-r');
  const rightButton = classnames(button);

  return (
    <div
      className={`flex ${orderClassName}`}
      style={{
        '--swiper-controls-background-color': theme.backgroundColor,
        '--swiper-controls-color': theme.color,
      }}
    >
      <div className="flex items-center justify-center w-12 lg:w-14 lg:h-13 text-snow h-11 bg-black-magic bg-opacity-60 stink-footnote">
        {realIndex !== null && `${swiper.realIndex + 1}/${carousel.length}`}
      </div>
      <div className="flex" data-behavior="carouselSelect">
        <button
          className={classnames(leftButton)}
          data-behavior="carouselSelectLeft"
          data-component-id="carousel_left_button"
          onClick={() => {
            swiper.slidePrev();
          }}
          style={{ borderColor: hexToRgba(theme.color, 0.5) }}
          type="button"
        >
          <Chevron className={classnames(leftChevron)} />
        </button>
        <button
          className={classnames(rightButton)}
          data-behavior="carouselSelectRight"
          data-component-id="carousel_right_button"
          onClick={() => {
            swiper.slideNext();
          }}
          type="button"
        >
          <Chevron className={classnames(rightChevron)} />
        </button>
      </div>
    </div>
  );
};

CardImageBasedXLargeControls.propTypes = {
  carousel: PropTypes.array,
  orderClassName: PropTypes.string,
  realIndex: PropTypes.number,
  swiper: PropTypes.object,
  theme: PropTypes.object,
};

export default CardImageBasedXLargeControls;
